<template>
  <a-card size="small" style="border-radius: 4px; margin-bottom: 16px;">
    <template slot="title">
      <div class="card-title" :class="rightTitle ? 'bg1' : 'bg2'">
        <div>{{title}}</div>
        <div v-if="rightTitle" class="right-title" @click="$emit('rightClick')">{{ rightTitle }}<a-icon type="right"/></div>
      </div>
    </template>
    <slot></slot>
  </a-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      defalut: ''
    },
    rightTitle: {
      type: String,
      defalut: ''
    }
  }
}
</script>

<style lang="less" scoped>
.card-title {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  height: 50px;
  color: #fff;
  line-height: 50px;
  border-radius:4px 4px 0 0;
  font-size: 18px;
  .right-title {
    font-size: 14px;
    cursor: pointer;
  }
}
.bg1 {
  background: url('@/config/images/newImages/bj1.gif');
}
.bg2 {
  background: url('@/config/images/newImages/bj1.gif');
}

/deep/ .ant-card-head {
  padding: 0 !important;
}
/deep/ .ant-card-head-title {
  padding: 0 !important;
}
</style>